import { searchMaterials } from "../../apiv2/materials";
import { INTENT } from "../../utils/constants";
import dispatchApi from "../utils/dispatchApi";

import { SEARCH_MATERIALS } from "./materials.actionTypes";

export const searchMaterialsAction = ({ search = "", withArchived = false }) => {
  return (dispatch) => {
    dispatchApi(
      dispatch,
      SEARCH_MATERIALS,
      () => searchMaterials({ search, withArchived }),
      INTENT.PERSISTENT
    );
  };
};
